import React, { forwardRef } from 'react';
import CircleProgress from './circle';
import LinearProgress from './linear';
const CnProgress = forwardRef(({ shape = 'line', ...others }, ref) => {
    return shape === 'line' ? (React.createElement(LinearProgress, { ...others, ref: ref })) : (React.createElement(CircleProgress, { ...others, ref: ref }));
});
CnProgress.displayName = 'CnProgress';
CnProgress.defaultProps = {
    size: 'medium',
    shape: 'line',
    percent: 0,
    state: 'normal',
    progressive: false,
    hasBorder: false,
    textRender: (percent) => `${Math.trunc(percent * 100) / 100}%`,
};
export default CnProgress;
